export function apiEndpoint(): string {

    let { hostname, origin } = window.location;

    if (hostname === "localhost" || hostname === "127.0.0.1:3000") {
        return "http://127.0.0.1:8000/api/"
    }
    return `${origin}/api/`

}